module.exports = __webpack_public_path__ + "img/thumb-014.e74dae1d.png";